import { revertSingleData } from "../apis/RevertSingleData";
import { toast } from "react-toastify";

export const handleRevert = async (id) => {
  try {
    const response = await revertSingleData(id);
    toast.success(response.message);
  } catch (error) {
    console.error("Error reverting data:", error);
    toast.error("Error reverting data");
  }
};
